// extracted by mini-css-extract-plugin
export default {"header":"styles_header__iOM8s","titlewrapper":"styles_titlewrapper__+NOPc","edit":"styles_edit__pKYIN"};